export default "__VITE_ASSET__tkWUPKir__"